import Banner, { BannerProps } from './Banner';

import { ReactComponent as InformationIcon } from '../../assets/information.svg';
import React from 'react';
import classNames from 'classnames';

interface WarningBannerProps extends BannerProps {}
export default function WarningBanner({ children, className, onClose }: WarningBannerProps) {
  return (
    <Banner
      className={classNames('banner--warning', className)}
      prefix={<InformationIcon />}
      onClose={onClose}
    >
      {children}
    </Banner>
  );
}
